<template>
    <div class="details">
         <el-scrollbar class="files_scroll" style="height: 600px">

        <div class="synopsis info">
            <div class="header">作品简介</div>
            <div class="content">
                {{detailsDate.material.description}}
            </div>
        </div>
        <div class="works info">
            <div class="header">素材信息</div>
            <div class="works_info">
                 <el-tooltip
                class="item"
                effect="dark"
                :content="detailsDate.material.title"
                placement="top-start"
              >
                <div class="txt-line1">文件标题：{{detailsDate.material.title}}</div>
                 </el-tooltip>
                <div v-for="(type, index) in detailsDate.types" :key="index" class="txt-line1">
                 <el-tooltip
                class="item"
                effect="dark"
                :content="type.typeSmalls"
                placement="top-start"
              >
                    <span>{{ type.typeBig }}：{{ type.typeSmalls || "" }}</span>
                  </el-tooltip>
                </div>
                <div class="txt-line1"> 上传者:{{ detailsDate.user.nickName }} </div>
                <div class="txt-line1">媒体类型：{{detailsDate.mediaType}}</div>
                <div class="txt-line1">原创类型：{{detailsDate.produceType}}</div>
                <div class="txt-line1">文件格式：{{detailsDate.material.suffix}}</div>
                <div class="txt-line1">文件大小：{{detailsDate.material.fileSize | calSize}}</div>
                <div class="txt-line1">发布时间：{{detailsDate.material.createTime}}</div>
                <div v-for="(itemv,keyv) in mediaInfo" :key="keyv+'o'" class="txt-line1">{{itemv.name}}：{{itemv.value}}</div>
            </div>
        </div>
           </el-scrollbar>
    </div>
</template>
<script>
import {calSize} from "@/utils";
export default {
    name:'DetailInfo',
    data(){
        return{
            baseurl: this.$http.requrl,
        }
    },
    filters: {
    calSize(fileSize) {
      return calSize(fileSize);
     },
    },
    props:{
        detailsDate:{
            type:Object,
            default:()=>{
                return {}
            }
        },
        mediaInfo:{
            type:Array,
            default:()=>{
                return []
            }
        }
    },
    methods:{
    
    }
}
</script>
<style lang="scss" scoped>
.details{
  

    .info{
        .header{
            line-height: 1;
            padding-bottom: 11px;
            border-bottom: 1px solid #EEEEEE;
            margin-bottom: 12px;
            font-size: 18px;
            color: #333;
        }
        .content{
            font-size: 14px;
            color: #999999;
            margin-bottom: 18px;
        }
        .character_info{
            height: 46px;
            display: flex;
            align-items: center;
            margin-bottom: 31px;
            .img_box{
                height: 46px;
                width: 46px;
                border-radius: 50%;
                overflow: hidden;
                // background: #000;
            img{
                height: 46px;
                width: 46px;
                border-radius: 50%;
            }
            }
            .author_detail{
                flex: 1;
                padding-left: 11px;
                .title{
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    margin-bottom: 4px;
                }
                .author_info{
                    font-size: 12px;
                    color: #999999;
                    display: flex;
                    justify-content: space-between;
                }
                
            }
        }
        .works_info{
            font-size: 16px;
            color: #999999;
            div{
                margin-bottom: 12px;
                line-height: 1;
            }
        }
    }
}
</style>